var __ckname = "msoffquoteemail";
var __okwin = "<strong>Thank you! Your quote request has been submitted successfully.Our customer service team will contact you within 1 business day.Please kindly wait for our reply.</strong>&nbsp;&nbsp;<a href='javascript:rewrite()'>重新提交</a>";
function checkEmail(v) {
    var emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/gi;
    return emailRegex.test(v);
}
function showTips(msg) {
    document.getElementById("tips").innerText = msg;
}
function rewrite() {
    deleteCookie(__ckname);
    this.location.reload();
}
/**
 * 设置Cookie
 * @param {string} name - Cookie名称
 * @param {string} value - Cookie值
 * @param {number} hours - 失效时间(小时), 默认1小时
 */
function setCookie(name, value, hours) {
    if (!hours || hours <= 0) {
        hours = 1; // 默认1小时
    }
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
    expires = "; expires=" + date.toUTCString();
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

/**
 * 读取Cookie
 * @param {string} name - Cookie名称
 * @returns {string|null} Cookie值, 不存在则返回null
 */
function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) === 0) {
            return c.substring(nameEQ.length, c.length);
        }
    }
    return null;
}

/**
 * 删除指定的Cookie
 * @param {string} name - Cookie名称
 */
function deleteCookie(name) {
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
}

window.onload = function () {
    var height = document.body.scrollHeight || document.documentElement.scrollHeight;
    window.parent.postMessage({ type: 'iframeHeight', height: height }, '*');
};

// 窗口大小变化时重新发送
window.onresize = function () {
    var height = document.body.scrollHeight || document.documentElement.scrollHeight;
    window.parent.postMessage({ type: 'iframeHeight', height: height }, '*');
};

$(document).ready(function () {
    if(getCookie(__ckname)=="1") {
        $("#context").html(__okwin);
        return;
    }
    $('.submit-btn').click(function () {
        // 获取表单数据
        var name = $('#name').val().trim();
        var email = $('#email').val().trim();
        var whatsapp = $('#whatsapp').val().trim();
        var company = $('#company').val().trim();
        var country = $('#country').val().trim();
        var projectStatus = $('#projectStatus').val();
        var budget = $('#budget').val();
        var messages = $('#messages').val().trim();

        // 获取选中的业务类型
        var businessTypes = [];
        $('.checkbox-item input[type="checkbox"]:checked').each(function () {
            businessTypes.push($(this).next('label').text());
        });

        // 验证必填项
        if (!name) {
            showTips('Please enter your name');
            return;
        }
        if (!email) {
            showTips('Please enter your email');
            return;
        }
        // 验证Email格式
        if (!checkEmail(email)) {
            showTips('Please enter a valid email address');
            return;
        }
        if (!company) {
            showTips('Please enter your company');
            return;
        }
        if (!country) {
            showTips('Please enter your country');
            return;
        }
        if (businessTypes.length === 0) {
            showTips('Please select at least one business type');
            return;
        }
        if (!messages) {
            showTips('Please enter your messages');
            return;
        }

        // 验证Whatsapp号码(如果填写了)
        if (whatsapp) {
            var phoneRegex = /^[\d\+\-\(\)\s]{6,20}$/;
            if (!phoneRegex.test(whatsapp)) {
                showTips('Please enter a valid whatsapp number');
                return;
            }
        }

        // 构建邮件内容
        var emailSubject = '来自【' + email + '】【' + name + '】的询价邮件';
        var emailBody = 'Name: ' + name + '\n' +
            'Email: ' + email + '\n' +
            'Whatsapp Number: ' + whatsapp + '\n' +
            'Company: ' + company + '\n' +
            'Country: ' + country + '\n' +
            'Business Type: ' + businessTypes.join(', ') + '\n' +
            'Project Status: ' + projectStatus + '\n' +
            'Budget: ' + budget + '\n' +
            'Messages: ' + messages;
        
        // AJAX提交
        $.ajax({
            url: 'https://www.msoffermakeup.com/home/SendQuote',
            type: 'POST',
            data: {
                subject: emailSubject,
                body: emailBody
            },
            success: function (response) {
                // 解析JSON字符串
                var result;
                if (typeof response === 'string') {
                    result = JSON.parse(response);
                } else {
                    result = response;
                }
                
                if (result.success) {
                    $("#context").html(__okwin);
                    setCookie(__ckname, "1");
                    window.parent.scrollTo(0, 0);
                    gtag('event', 'form_submit', {
                        event_category:'Lead',
                        event_label:'OEM询价表单'
                    });
                    // 滚动到顶部
                    //window.parent.postMessage({ type: 'iframeHeight', height: 500 }, '*');
                    //showTips('Thank you! Your quote request has been submitted successfully.');
                    //// 清空表单
                    //$('input[type="text"], input[type="email"], input[type="tel"], textarea').val('');
                    //$('input[type="checkbox"]').prop('checked', false);
                    //$('select').prop('selectedIndex', 0);
                } else {
                    showTips('Sorry, there was an error submitting your request. Please try again.');
                }
            },
            error: function () {
                showTips('Sorry, there was an error submitting your request. Please try again.');
            }
        });
    });
});